import { appMethod as app } from '@utils/app';
import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { List, Radio, Checkbox } from 'antd-mobile';

import './SelectEleCustomComponent.less';

export default function SelectEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const titleStyleObj = {
    backgroundColor: customFeature.lineBackgroundColor,
    color: customFeature.secColor,
    fontSize: transformPx2Rem(customFeature.secFontSize, 320),
    lineHeight: transformPx2Rem(customFeature.secLineHeight, 320),
    fontWeight: transformPx2Rem(customFeature.secFontWeight, 320),
    fontStyle: customFeature.secFontStyle,
    textDecoration: customFeature.secTextDecoration,
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 根据customFeature.type字段生成对应内容
   */
  const $content = () => {
    // 组件类型、选中样式
    const { type, select_style, multiSelection } = customFeature;
    if (type === undefined) {
      return <div>当前展示类型不存在，请重新设置</div>; // 数据太久 TODO
    } else if (type === 0) {
      // 是否多选
      if (multiSelection) {
        return <List>
          {content.lists.map((item, index) => (<div key={index} className="select-item">
            <Checkbox.CheckboxItem
              disabled={data.selectedData && (data.customFeature.maxSelect == data.selectedData.itemLength && data.selectedData[item] != 1)}
              checked={data.content.selectArr && data.content.selectArr[index]}
              onChange={(e) => selectOptionOne(e, {
                value: item,
                segment: data.customFeature.segment,
                datakey: `eles[${formCompindex}].form_data.${customFeature.segment}`,
                compindex: props.index,
                formcompindex: formCompindex
              })}
              data-value={item}
              data-segment={data.customFeature.segment}
              data-datakey={`eles[${formCompindex}].form_data.${customFeature.segment}`}
              data-compindex={props.index}
              data-formcompindex={formCompindex}
              >
              <div className="select-text">{item}</div>
            </Checkbox.CheckboxItem>
          </div>))}
        </List>;
      } else {
        return <List>
          {content.lists.map((item, index) => (<div key={index} className="select-item">
            <Radio.RadioItem
              checked={item == form_data[data.customFeature.segment]}
              onChange={(e) => selectOptionOne(e, {
                value: item,
                segment: data.customFeature.segment,
                datakey: `eles[${formCompindex}].form_data.${customFeature.segment}`,
                compindex: props.index,
                formcompindex: formCompindex
              })}
              data-value={item}
              data-segment={data.customFeature.segment}
              data-formcompindex={formCompindex}
              data-datakey={`eles[${formCompindex}].form_data.${customFeature.segment}`}
              >
              <div className="select-text">{item}</div>
            </Radio.RadioItem>
          </div>))}
        </List>;
      }
    } else if (type === 1) {
      return content.lists.map((item, index) => (<div key={index} className="select-list" 
        onClick={selectOptionSecond}
        data-segment={data.customFeature.segment}
        data-index={index}
        data-compindex={props.index}
        data-formcompindex={formCompindex}
        style={{
          borderWidth: transformPx2Rem(select_style['border-width'], 320),
          borderStyle: select_style['border-style'],
          borderColor: data.selectedValue && (data.selectedValue[index] === index ? select_style['border-active-color'] : select_style['border-color']),
        }}
        >
        {data.selectedValue && (data.selectedValue[index] == index) &&
          <div className="icoo-moon icon-gou"
            style={{
              background: `-webkit-gradient(linear, right top, left bottom, from(${ data.customFeature.select_style['border-active-color'] }), color-stop(0.5, ${ data.customFeature.select_style['border-active-color'] }), color-stop(0.5, rgba(255, 0, 0,0)), to(rgba(255, 0, 0,0)))`
            }}
          ></div>}
        {item}
      </div>));
    }
  }
  /**
   *  绑定事件 
   */
  function selectOptionOne(event, dataset = {}) {
    event.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let value = dataset.value;
    let datakey = dataset.datakey;
    let segment = dataset.segment;
    let compindex = dataset.compindex;
    let formcompindex = dataset.formcompindex;
    if (!segment) {
      app.showModal({
        content: '该组件【选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    let newdata = {};
    let selectKey = {}
    newdata[datakey] = value;
    if (newdata[datakey].constructor === Array) {
      newdata[datakey] = newdata[datakey].join();
      for (let i in value) {
        selectKey[value[i]] = 1;
      }
      selectKey.itemLength = value.length
    }else{
      selectKey[value] = 1;
      selectKey.itemLength = 1;
    }
    newdata['eles[' + formcompindex +'].content[' + compindex + '].selectedData'] = selectKey
    pageInstance.setData(newdata);

  }
  function selectOptionSecond(event) {
    event.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let formcompindex = dataset.formcompindex;
    let segment = customFeature.segment;
    let multi = customFeature.multiSelection;
    let min = customFeature.minSelect;
    let max = customFeature.maxSelect;
    let datakey = `eles[${formCompindex}].form_data.${customFeature.segment}`;
    let selectedValue = data.selectedValue;
    let selectedData = data.content.lists;
    let newdata = {};
    let dataArray = [];

    if (!segment) {
      app.showModal({
        content: '该组件【选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    let componentKey = 'eles[' + formcompindex +'].content[' + compindex + ']';
    newdata[componentKey + '.selectedValue'] = selectedValue ? selectedValue : [];
    if (multi){
      let arrLength = 0;
      if (newdata[componentKey + '.selectedValue'][index] === index) {
        newdata[componentKey + '.selectedValue'][index] = null;
      } else {
        newdata[componentKey + '.selectedValue'][index] = index;
      }
      for (let i = 0; i < newdata[componentKey + '.selectedValue'].length; i++) {
        let dataIndex = newdata[componentKey + '.selectedValue'][i];
        if (dataIndex != null) {
          arrLength++;
          if (arrLength > max){
            app.showModal({
              content: '最多选择' + max + '项'
            });
            return;
          }
          dataArray.push(selectedData[dataIndex]);
        }
        newdata[datakey] = dataArray.join(',');
      }
    }else{
      newdata[datakey] = '';
      if (newdata[componentKey + '.selectedValue'][index] === index) {
        newdata[componentKey + '.selectedValue'][index] = null;
      }else{
        newdata[componentKey + '.selectedValue'] = [];
        newdata[componentKey + '.selectedValue'][index] = index;
        newdata[datakey] = selectedData[index];
      }
    }
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component select-ele type-${customFeature.type}`} style={styleObj}>
      <div className="select-container">
        <div className="title-container" style={titleStyleObj}>
          <span className="title">{data.content.title}</span>
        </div>
        {$content()}
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/select-ele-custom-component/SelectEleCustomComponent.jsx